<template>
  <section class="banner__area pt-20 pb-10">
    <div class="container">
      <div class="row">
        <div v-for="banner in adsByType" :key="banner.id" class="col-xl-4 col-lg-4 col-md-6">
          <div class="banner__item p-relative w-img mb-30">
            <div class="banner__img">
              <router-link href="/shop">
                <img :src="banner.image_url" :alt="banner.title" />
              </router-link>
            </div>
            <div class="banner__content">
              <h6>
                <router-link href="/shop">
                  <div v-html="banner.title"></div>
                </router-link>
              </h6>
              <p>{{ banner.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    ads: {
      type: Array,
      required: true,
    },

  },
  computed: {
    adsByType() {
      // Group ads by their add_type
      const groupedAds = {};
      this.ads.forEach(ad => {
        if ([1,2,3].includes(ad.add_type)) {
          groupedAds[ad.add_type] = ad;
        }
      });
      return groupedAds;
    },
  },

};
</script>

<style scoped>
/* Add any necessary custom styles here */
</style>
